import React, { useContext, useEffect } from 'react';
import Entity from './Entity';
import { useHistory } from 'react-router-dom';
import useIsMobile from '../hooks/useIsMobile';
import { UserContext } from '../context/UserContext';

const EntitySelector = (props) => {
	const { setIsFIP, isFip } = useContext(UserContext);
	const EntityType = ['ACCOUNTS', 'APPS'];
	const history = useHistory();
	const isMobile = useIsMobile();
	const fiuParam = props.location?.state?.fiuParam || null;
	
	const handleEntityClick = (type) => {
		const path = type.toLowerCase();
		if (type === 'ACCOUNTS') {
			setIsFIP(true);
		}
		history.push({
			pathname: `/revoke-consent`,
			state: { fiuParam: fiuParam }
		});
	};

	useEffect(() => {
		if (global.ecid) {
			history.push(`/revoke-consent`);
		}
		else{
			setIsFIP(false);
		}
		// Auto-open APPS WISE if mobileNumber was from URL params
		if (props.location?.state?.autoOpenApps) {
			handleEntityClick('APPS');
		}
	}, []);

	return (
		<div
			style={{
				width: isMobile ? '95%' : '40%',
				margin: '0 auto',
				marginTop: isMobile? '5rem' : '10rem',
				marginBottom: '5rem',
			}}
		>
			<div >
				<p
					style={{
						textAlign: 'left',
						fontSize: props?.customDetails?.fontSize,
						color: props?.customDetails?.textColor,
						wordSpacing: '0.1rem',
					}}
				>
					PLEASE CHOOSE WHICH CONSENTS YOU WOULD LIKE TO VIEW AND MANAGE
				</p>
			</div>
			<div >
				{EntityType.map((type, index) => {
					return (
						<Entity
							entityKey={type.toLowerCase()}
							key={index}
							onClick={() => handleEntityClick(type)}
							customDetails={props.customDetails}
							type={type}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default EntitySelector;
